// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import styles from './styles.css.js';

const ResizeHandler = <span className={styles['resizable-box-handle']} />;

export default ResizeHandler;
